(function () {
  if (window.__urgeMotionInit) return;
  window.__urgeMotionInit = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function onReady(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  onReady(function () {
    // Swap header logo to Figma asset when available
    try {
      var logoUrl = window.URGE_LOGO_URL || window.URGE_LOGO_SM_URL;
      if (logoUrl) {
        document.querySelectorAll(".header-logo__image, .header-logo img, [data-testid=\"header-logo\"] img").forEach(function (img) {
          img.src = logoUrl;
          img.srcset = "";
          img.removeAttribute("srcset");
          img.alt = img.alt || "Urge Candies";
          img.style.objectFit = "contain";
        });
      }
    } catch (e) {}

    if (reduce) {
      document.querySelectorAll(".urge-reveal").forEach(function (el) {
        el.classList.add("is-in");
      });
      return;
    }

    var nodes = document.querySelectorAll(".urge-reveal");
    if (!nodes.length || !("IntersectionObserver" in window)) {
      nodes.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
    );

    nodes.forEach(function (el) { io.observe(el); });
  });
})();
